<template>
    <div class="tableHeaderCheckboxFilter">
        <table-header-checkbox-filter :items="items" @change-active="onChangeActive">
            <div class="search">
                <input type="text" class="form-control" v-model="searchString" placeholder="Search" />
            </div>
        </table-header-checkbox-filter>
    </div>
</template>

<script>
import TableHeaderCheckboxFilter from './TableHeaderCheckboxFilter';

export default {
    name: 'SearchableTableHeaderCheckboxFilter',

    components: {
        TableHeaderCheckboxFilter
    },

    props: {
        items: {
            type: Array,
            validator(value) {
                return value.every(entry => entry.hasOwnProperty('item') && entry.hasOwnProperty('selected'));
            },
            default: () => []
        }
    },

    data() {
        return {
            searchString: ''
        };
    },

    computed: {
        isActiveSearch() {
            return this.searchString.length > 0;
        },
        innerModel() {
            if (this.isActiveSearch) {
                const isMatchingItem = item => {
                    return item.toLowerCase().includes(this.searchString.toLowerCase());
                };
                return this.items.filter(({ item }) => isMatchingItem(item));
            }
            return this.items;
        }
    },

    methods: {
        onChangeActive(isActive) {
            this.$emit('change-active', isActive);
        }
    }
};
</script>

<style lang="scss" scoped>
.search {
    padding: 4px 15px;
}
</style>
